<template>
  <DragPanel
    title="开挖编辑"
    :closePanel="closePanel"
    :tooltipVisible="false"
    ref="dom">
    <div class="edit-extrude-box">
      <div class="steps-box">
        <div class="step-item-box">
          <div :class="getStepIndexClassName(1)">1</div>
          <div :class="getStepNameClassName(1)">区域编辑</div>
        </div>
        <div class="step-connector-line" />
        <div class="step-item-box">
          <div :class="getStepIndexClassName(2)">2</div>
          <div :class="getStepNameClassName(2)">属性编辑</div>
        </div>
      </div>
      <div class="extrude-name-box">
        <div class="name-box">
          <div class="label dialog-label">名称：</div>
          <div
            class="name text-overflow dialog-label"
            :title="extrudeName">
            {{ extrudeName }}
          </div>
        </div>
        <div
          class="common-button-box"
          v-show="currStep === 1">
          <el-button
            class="normal-btn"
            size="small"
            @click="exportExtrudeReg">
            导出绘制区域
          </el-button>
        </div>
      </div>
      <div
        class="first-step-box"
        v-show="currStep === 1">
        <div class="uniform-height-box">
          <div class="label-box">
            <div class="name dialog-label">统一顶点高度</div>
            <el-tooltip
              :effect="$theme.tooltipKey()"
              placement="top-start"
              popper-class="common-panel-tooltip-box">
              <div slot="content">
                在绘制矢量面时，由于手动操作可能存在偏差，各顶点可能出现高低不平的情况。为确保图形平整，您可在完成绘制后使用高度统一功能，一键将所有顶点智能对齐到相同水平面，消除高度误差
              </div>
              <div class="icon-box">
                <icon-svg icon-class="ic-jieshishuoming" />
              </div>
            </el-tooltip>
            <div>:</div>
          </div>
          <div
            :class="`icon-btn-box ${isPickUpHeightEnable ? 'active' : ''}`"
            @click="pickUpHeight">
            <icon-svg icon-class="icon-shiqubingtongyidingdiangaodu" />
          </div>
        </div>
      </div>
      <div
        class="last-step-box"
        v-show="currStep === 2">
        <div class="item-box">
          <div class="label-box">
            <div class="name dailog-label">开挖区域可影响的场景对象</div>
            <el-tooltip
              :effect="$theme.tooltipKey()"
              placement="top-start"
              popper-class="common-panel-tooltip-box">
              <div slot="content">
                <div>(1) 调整开挖区域后，平台会自动计算哪些数据集被影响。</div>
                <div>(2) 开挖效果仅针对单一数据集。</div>
              </div>
              <div class="icon-box">
                <icon-svg icon-class="ic-jieshishuoming" />
              </div>
            </el-tooltip>
            <div>:</div>
          </div>
        </div>
        <el-scrollbar class="extrude-affect-list">
          <el-radio-group
            v-model="affectedDataSetId"
            @input="handleRadioChange">
            <div
              class="common-radio-box"
              v-for="(item, index) in affectDataSetList"
              :key="index">
              <el-radio
                :label="item.dataSetId"
                class="radio-primary">
                <div v-if="item.isTerrType && item.linkDataSets.length > 1">
                  <div
                    v-for="(element, index) in item.linkDataSets"
                    :key="index"
                    class="link-dataset-box">
                    <div class="link-tip-box">
                      <div class="icon-box">
                        <icon-svg icon-class="ic-lianjieshu" />
                      </div>
                      <div class="link-line" />
                      <div class="layer-name">
                        {{ element.dataSetName }}
                      </div>
                    </div>
                    <div class="link-dataset-line" />
                  </div>
                </div>
                <div
                  v-else
                  class="layer-name">
                  {{ item.dataSetName }}
                </div>
              </el-radio>
            </div>
          </el-radio-group>
        </el-scrollbar>
        <div class="item-box">
          <div class="label-box">
            <div class="name dialog-label extrudeMethod">开挖形式</div>
            <el-tooltip
              :effect="$theme.tooltipKey()"
              placement="top-start"
              popper-class="common-panel-tooltip-box">
              <div slot="content">
                <div>开挖支持三种形式：</div>
                <div>(1) 底部开口</div>
                <div>适用数据：倾斜摄影、BIM模型</div>
                <div>(2) 底部封口并使用原纹理</div>
                <div>适用数据：倾斜摄影、遥感影像、WMTS地图服务</div>
                <div>(3) 底部封口并使用指定纹理</div>
                <div>适用数据：倾斜摄影、BIM模型</div>
              </div>
              <div class="icon-box">
                <icon-svg icon-class="ic-jieshishuoming" />
              </div>
            </el-tooltip>
            <div>:</div>
          </div>
          <div class="common-select-box">
            <el-select
              class="primary-select"
              size="small"
              v-model="extrudeType"
              :popper-append-to-body="false"
              @change="handleExtrudeTypeChange">
              <el-option
                v-for="(item, index) in extrudeTypeList"
                :key="index"
                :value="item.value"
                :label="item.name" />
            </el-select>
          </div>
        </div>
        <div
          class="item-box"
          v-if="extrudeType === 2">
          <div class="label-box">选择纹理：</div>
          <div class="texture-box">
            <div
              class="curr-texture-box"
              @click.stop="toggleTextureList">
              <!-- prettier-ignore -->
              <div class="img-box" :style="`background-image:url(${getCurrTexture(currTextureId)})`" />
              <div class="icon-box">
                <i class="el-icon-caret-bottom" />
              </div>
            </div>
            <div
              class="texture-select-box"
              v-if="isTextureListVisible">
              <div
                v-for="(item, index) in textureList"
                :key="index"
                class="texture-item-box"
                @click="handleTextureChange(item)">
                <img :src="getCurrTexture(item.textureId)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="operation-box">
      <div
        class="common-button-box"
        v-if="currStep === 1">
        <el-button
          size="small"
          class="primary-btn primary-ang-btn"
          type="primary"
          @click="nextStep">
          下一步
        </el-button>
      </div>
      <div
        class="common-button-box"
        v-if="currStep === 2">
        <el-button
          size="small"
          class="normal-btn primary-ang-btn"
          @click="lastStep">
          上一步
        </el-button>
        <el-button
          size="small"
          type="primary"
          class="primary-btn primary-ang-btn"
          @click="saveExtrude">
          保存
        </el-button>
      </div>
    </div>
  </DragPanel>
</template>

<script>
import * as turf from '@turf/turf'

import DragPanel from '@/components/CustomDragPanel.vue'

import { Store } from '@/utils/store'

import { editExtrudeService } from '@/service/interface.js'

export default {
  data() {
    return {
      currStep: 1,
      activeSteps: [1],

      extrudeName: '',
      isPickUpHeightEnable: false,

      affectedDataSetId: '',
      affectDataSetList: [],
      extrudeType: 0,
      extrudeTypeList: [],
      currTextureId: '',
      textureList: [],
      isTextureListVisible: false,

      // 当前选中的矢量边，作为是否给出操作提示的依据
      currElemType: '',
      currEdgeId: '',
      originX: -1,
      originY: -1
    }
  },
  props: {
    extrudeNodeInfo: Object,
    updateSceneTree: Function,
    findAllDataSets: Function,
    closeExtrudePanel: Function
  },
  components: {
    DragPanel
  },
  mounted() {
    this.init()

    document.addEventListener('RESystemSelElement', this.onSelElement)
    document.addEventListener('RESystemSelShpElement', this.onSelElement)
    // 用于隐藏指定纹理下拉列表
    document.addEventListener('click', this.handleDocumentClick)
    this.addCanvasEventListener()
  },
  beforeDestroy() {
    document.removeEventListener('RESystemSelElement', this.onSelElement)
    document.removeEventListener('RESystemSelShpElement', this.onSelElement)
    // 用于隐藏指定纹理下拉列表
    document.removeEventListener('click', this.handleDocumentClick)
    this.removeCanvasEventListener()
  },
  methods: {
    init() {
      let extrudeNodeInfo = this.extrudeNodeInfo
      this.extrudeName = extrudeNodeInfo.nodeName

      let extrudeInfo = extrudeNodeInfo.excavateInfo
      let extrudeGeoJson = JSON.parse(extrudeInfo.geoJson)
      this.extrudeType = extrudeGeoJson.type

      let dataSets = this.findAllDataSets()
      let affectedDataSetResId = extrudeGeoJson.dataSetIdList[0]
      let find = dataSets.find(item => {
        let resId = item.dataSetId.replaceAll('-', '')
        if (resId === affectedDataSetResId) {
          return true
        } else {
          return false
        }
      })
      this.affectedDataSetId = find?.dataSetId

      let textureList = Store.extrudeTextureList
      this.textureList = textureList

      if (this.extrudeType === 2) {
        let find = textureList.find(
          el => el.textureGuid === extrudeInfo.textureFileDataId
        )
        this.currTextureId = find.textureId
      }

      const Extrude = window.BlackHole3D.Extrude
      let extrudeID = extrudeInfo.id
      Extrude.setCamToData([extrudeID])
      Extrude.startEditState()
      Extrude.setShowState([extrudeID], 0)

      this.setPanelStyle()
    },
    exportExtrudeReg() {
      let extrudeInfo = this.extrudeNodeInfo.excavateInfo
      let extrudeID = extrudeInfo.id
      let regGeoJson = this.getExtrudeRegData(extrudeID)
      regGeoJson = JSON.stringify(regGeoJson)
      // 创建一个 Blob 对象，指定类型为 JSON
      const blob = new Blob([regGeoJson], { type: 'application/json' })

      // 创建一个链接元素
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob) // 生成下载链接
      link.download = `${this.extrudeName}.json` // 设置下载文件名

      // 触发下载
      link.click()

      // 释放 URL 对象
      URL.revokeObjectURL(link.href)
    },
    pickUpHeight() {
      this.isPickUpHeightEnable = true
    },
    nextStep() {
      const Extrude = window.BlackHole3D.Extrude
      Extrude.endEditState()

      let extrudeInfo = this.extrudeNodeInfo.excavateInfo
      let extrudeID = extrudeInfo.id

      let affectDataSetList = this.getAffectDataSetList(extrudeInfo)
      if (affectDataSetList.length) {
        this.affectDataSetList = affectDataSetList

        // prettier-ignore
        let find = affectDataSetList.find((el) => el.dataSetId === this.affectedDataSetId);
        let defaultDataSet
        if (find) {
          defaultDataSet = find
          Extrude.setShowType(extrudeID, this.extrudeType)
          this.setExtrudeTypeListByDataSetType(defaultDataSet.dataSetType)
        } else {
          defaultDataSet = affectDataSetList[0]
          this.setExtrudeTypeListByDataSetType(defaultDataSet.dataSetType)
          this.extrudeType = this.extrudeTypeList[0].value
          Extrude.setShowType(extrudeID, this.extrudeType)
        }

        this.affectedDataSetId = defaultDataSet.dataSetId

        let scopeDataSetIds = []
        if (defaultDataSet.isTerrType) {
          let linkDataSets = defaultDataSet.linkDataSets
          scopeDataSetIds = linkDataSets.map(el => el.resId)
        } else {
          scopeDataSetIds = [defaultDataSet.resId]
        }
        Extrude.setDataSetScope(extrudeID, scopeDataSetIds)
      } else {
        this.$message.warning('当前区域没有可影响的数据集，无法进行开挖')
        return
      }

      this.currMode = 'preview'

      this.currStep = 2
      if (!this.activeSteps.includes(2)) {
        this.activeSteps.push(2)
      }

      this.setPanelStyle()
    },
    lastStep() {
      let extrudeInfo = this.extrudeNodeInfo.excavateInfo
      let extrudeID = extrudeInfo.id

      const Extrude = window.BlackHole3D.Extrude
      Extrude.startEditState()
      Extrude.setShowState([extrudeID], 0)
      this.currMode = 'edit'

      this.currStep = 1
      this.setPanelStyle()
    },
    handleExtrudeTypeChange(value) {
      let extrudeInfo = this.extrudeNodeInfo.excavateInfo
      let extrudeID = extrudeInfo.id
      const Extrude = window.BlackHole3D.Extrude
      Extrude.setShowType(extrudeID, value)

      if (value === 2) {
        this.currTextureId = this.textureList[0].textureId
        Extrude.setExtrudeTexId(extrudeID, this.currTextureId)
      }

      this.setPanelStyle()
    },
    handleTextureChange(textureInfo) {
      const Extrude = window.BlackHole3D.Extrude

      let textureId = textureInfo.textureId
      if (textureId !== this.currTextureId) {
        this.currTextureId = textureId
        let extrudeInfo = this.extrudeNodeInfo.excavateInfo
        let extrudeID = extrudeInfo.id
        Extrude.setExtrudeTexId(extrudeID, textureId)
      }
    },
    handleRadioChange(value) {
      let find = this.affectDataSetList.find(el => el.dataSetId === value)
      this.setExtrudeTypeListByDataSetType(find.dataSetType)
      this.extrudeType = this.extrudeTypeList[0].value

      const Extrude = window.BlackHole3D.Extrude
      let extrudeInfo = this.extrudeNodeInfo.excavateInfo
      let extrudeID = extrudeInfo.id
      let scopeDataSetIds = []
      if (find.isTerrType) {
        let linkDataSets = find.linkDataSets
        scopeDataSetIds = linkDataSets.map(el => el.resId)
      } else {
        scopeDataSetIds = [find.resId]
      }
      Extrude.setDataSetScope(extrudeID, scopeDataSetIds)
      Extrude.setShowType(extrudeID, this.extrudeType)

      this.setPanelStyle()
    },
    resetExtrude() {
      const BlackHole3D = window.BlackHole3D
      if (this.currStep === 1) {
        BlackHole3D.Extrude.endEditState()
      }

      let extrudeNodeInfo = this.extrudeNodeInfo
      let extrudeInfo = extrudeNodeInfo.excavateInfo
      let extrudeGeoJson = JSON.parse(extrudeInfo.geoJson)

      let extrudeInstance = new BlackHole3D.REExtrudeInfo()
      extrudeInstance.extrudeId = extrudeInfo.id
      extrudeInstance.dataSetIdList = extrudeGeoJson.dataSetIdList
      extrudeInstance.rgnList = extrudeGeoJson.rgnList
      extrudeInstance.depthLimitRange = extrudeGeoJson.depthLimitRange
      extrudeInstance.type = extrudeGeoJson.type
      extrudeInstance.texId = extrudeGeoJson.texId
      BlackHole3D.Extrude.setData([extrudeInstance])
    },
    setExtrudeTypeListByDataSetType(dataSetType) {
      const extrudeTypeList = [
        {
          value: 0,
          name: '底部开口',
          dataSetType: [0, 11]
        },
        {
          value: 1,
          name: '底部封口并使用原纹理',
          dataSetType: [10, 11, 13]
        },
        {
          value: 2,
          name: '底部封口并使用指定纹理',
          dataSetType: [0, 11]
        }
      ]
      this.extrudeTypeList = extrudeTypeList.filter(el =>
        el.dataSetType.includes(dataSetType)
      )
    },
    saveExtrude() {
      this.saveExtrudeRequest().then(() => {
        this.updateSceneTree().then(() => {
          this.$message.success('保存成功')
          this.closeExtrudePanel()
        })
      })
    },
    saveExtrudeRequest() {
      return new Promise(resolve => {
        const Extrude = window.BlackHole3D.Extrude
        let extrudeInfo = this.extrudeNodeInfo.excavateInfo
        let extrudeID = extrudeInfo.id
        let extrudeData = Extrude.getData([extrudeID])
        let extrudeDataInfo = extrudeData[0]
        let findCurrTexture = this.textureList.find(
          el => el.textureId === this.currTextureId
        )
        let find = this.affectDataSetList.find(
          el => el.dataSetId === this.affectedDataSetId
        )
        let treeNodeIds = {}
        if (find.isTerrType) {
          let linkDataSets = find.linkDataSets
          linkDataSets.forEach(item => {
            treeNodeIds[item.treeNodeId] = true
          })
        } else {
          treeNodeIds[find.treeNodeId] = true
        }

        let params = {
          nodeId: this.extrudeNodeInfo.nodeId,
          digType: this.extrudeType,
          // prettier-ignore
          textureFileDataId: this.extrudeType === 2 ? findCurrTexture.textureGuid : undefined,
          geojson: JSON.stringify(extrudeDataInfo),
          treeNodeIds
        }
        editExtrudeService(params).then(response => {
          if (response.isSuccess) {
            resolve(response)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    closePanel() {
      return new Promise(resolve => {
        let isCheckPass = this.isUnSaveCheck()

        if (isCheckPass) {
          if (this.currStep === 1) {
            window.BlackHole3D.Extrude.endEditState()
          }
          this.closeExtrudePanel()
          resolve()
          return
        }

        this.$confirm('您编辑的内容未被保存，确定要退出吗？', '提示', {
          confirmButtonText: '保存并退出',
          cancelButtonText: '直接退出',
          distinguishCancelAndClose: true,
          type: 'warning'
        })
          .then(() => {
            if (this.currStep === 1) {
              this.setExtrudeEffect()
            }
            this.saveExtrude()
            resolve()
          })
          .catch(e => {
            if (e === 'cancel') {
              this.resetExtrude()
              this.closeExtrudePanel()
              resolve()
            }
          })
      })
    },
    setExtrudeEffect() {
      const Extrude = window.BlackHole3D.Extrude
      Extrude.endEditState()

      let extrudeInfo = this.extrudeNodeInfo.excavateInfo
      let extrudeID = extrudeInfo.id

      this.affectDataSetList = this.getAffectDataSetList(extrudeInfo)
      let affectDataSet
      let find = this.affectDataSetList.find(
        el => el.dataSetId === this.affectedDataSetId
      )
      if (find) {
        affectDataSet = find
      } else {
        affectDataSet = this.affectDataSetList[0]
        this.affectedDataSetId = affectDataSet.dataSetId
        this.setExtrudeTypeListByDataSetType(affectDataSet.dataSetType)
        this.extrudeType = this.extrudeTypeList[0].value
        Extrude.setShowType(extrudeID, this.extrudeType)
      }

      let scopeDataSetIds = []
      if (affectDataSet.isTerrType) {
        let linkDataSets = affectDataSet.linkDataSets
        scopeDataSetIds = linkDataSets.map(el => el.resId)
      } else {
        scopeDataSetIds = [affectDataSet.resId]
      }
      Extrude.setDataSetScope(extrudeID, scopeDataSetIds)
    },
    isUnSaveCheck() {
      let isCheckPass = true
      let isExtrudeRegChange = this.isRegChange()
      let isExtrudeAttrChange = this.isAttrChange()

      if (isExtrudeRegChange || isExtrudeAttrChange) {
        isCheckPass = false
      }

      return isCheckPass
    },
    isRegChange() {
      let extrudeInfo = this.extrudeNodeInfo.excavateInfo
      let geoJson = JSON.parse(extrudeInfo.geoJson)
      let originRgnList = geoJson.rgnList
      let originPointList = originRgnList[0]

      const Extrude = window.BlackHole3D.Extrude
      let extrudeID = extrudeInfo.id
      let extrudeData = Extrude.getData([extrudeID])
      let newExtrudeInfo = extrudeData[0]
      let newRgnList = newExtrudeInfo.rgnList
      let newPointList = newRgnList[0]

      let isChange = this.isArrayChanged(originPointList, newPointList)
      return isChange
    },
    isArrayChanged(originPoints, newPoints) {
      if (originPoints.length !== newPoints.length) return true

      return originPoints.some((point1, index) => {
        const point2 = newPoints[index]
        // prettier-ignore
        return  point1[0] !== point2[0] || point1[1] !== point2[1] || point1[2] !== point2[2];
      })
    },
    isAttrChange() {
      let extrudeInfo = this.extrudeNodeInfo.excavateInfo
      let extrudeGeoJson = JSON.parse(extrudeInfo.geoJson)
      let originExtrudeType = extrudeGeoJson.type
      let originExtrudeTexGuId = extrudeInfo.textureFileDataId

      let newExtrudeType = this.extrudeType
      let newExtrudeTexGuId = null
      if (newExtrudeType === 2) {
        let find = this.textureList.find(
          el => el.textureId === this.currTextureId
        )
        newExtrudeTexGuId = find.textureGuid
      }

      if (originExtrudeType !== newExtrudeType) {
        return true
      }

      if (originExtrudeTexGuId !== newExtrudeTexGuId) {
        return true
      }

      return false
    },
    // 处理元素点击事件(包括普通数据和矢量数据点击)，用于拾取高度
    onSelElement(eventInfo) {
      const BlackHole3D = window.BlackHole3D
      let currProbeRet = BlackHole3D.Probe.getCurCombProbeRet()
      let { elemType, elemId } = currProbeRet

      if (this.currEdgeId === elemId) {
        this.currElemType = ''
        this.currEdgeId = ''
        return
      }

      if (elemType === 'ShapeElem') {
        if (elemId && elemId.includes('EXTRUDE_EDGE')) {
          // this.$message.info("再次点击选中边可以添加中点");
          this.currElemType = 'EXTRUDE_EDGE'
          this.currEdgeId = elemId
        } else {
          this.currElemType = ''
        }
      } else {
        this.currElemType = ''
        this.currEdgeId = ''
      }

      if (!this.isPickUpHeightEnable) return

      // 右键取消拾取高度
      let eventDetail = eventInfo.detail
      if (eventDetail.button === 1) {
        this.isPickUpHeightEnable = false

        let coorInfo = { visible: false }
        this.$eventManage.fire('canvasMouseMove', { coorInfo })
        return
      }

      let currPos = currProbeRet.elemPos
      if (currPos.length) {
        let height = Number(currPos[2].toFixed(2))

        const Extrude = window.BlackHole3D.Extrude

        let extrudeNodeInfo = this.extrudeNodeInfo
        let extrudeID = extrudeNodeInfo.excavateInfo.id
        let extrudeData = Extrude.getData([extrudeID])
        let extrudeInfo = extrudeData[0]
        let rgnList = extrudeInfo.rgnList
        let pointList = rgnList[0]
        pointList.forEach(point => {
          point[2] = height
        })

        Extrude.setData(extrudeData)

        Extrude.endEditState()

        Extrude.startEditState()
        Extrude.setShowState([extrudeID], 0)
      }

      this.isPickUpHeightEnable = false

      let coorInfo = { visible: false }
      this.$eventManage.fire('canvasMouseMove', { coorInfo })
    },
    toggleTextureList() {
      this.isTextureListVisible = !this.isTextureListVisible
    },
    handleDocumentClick() {
      this.isTextureListVisible = false
    },
    addCanvasEventListener() {
      let domRef = null
      if (window.BlackHole3D) {
        domRef = window.BlackHole3D.canvas
      } else {
        domRef = document.getElementById('engineCanvas')
      }
      domRef.addEventListener('click', this.onCanvasClick)
      domRef.addEventListener('mouseup', this.onCanvasMouseUp)
      domRef.addEventListener('mousemove', this.onCanvasMouseMove)
      domRef.addEventListener('mouseleave', this.onCanvasMouseLeave)
    },
    removeCanvasEventListener() {
      let domRef = null
      if (window.BlackHole3D) {
        domRef = window.BlackHole3D.canvas
      } else {
        domRef = document.getElementById('engineCanvas')
      }
      domRef.removeEventListener('click', this.onCanvasClick)
      domRef.removeEventListener('mouseup', this.onCanvasMouseUp)
      domRef.removeEventListener('mousemove', this.onCanvasMouseMove)
      domRef.removeEventListener('mouseleave', this.onCanvasMouseLeave)
    },
    onCanvasClick(eventInfo) {
      // 由于canvaClick事件早于RESystemSelShpElement事件触发，因此增加延迟，以获取RESystemSelShpElement事件中拿到的数据
      setTimeout(() => {
        if (this.currElemType === 'EXTRUDE_EDGE' && this.currEdgeId) {
          this.originX = eventInfo.clientX
          this.originY = eventInfo.clientY

          let coorInfo = {
            visible: true,
            tipContent: '再次点击选中边可以添加中点',
            clientX: eventInfo.clientX,
            clientY: eventInfo.clientY
          }
          this.$eventManage.fire('canvasMouseMove', { coorInfo })
        } else {
          this.originX = -1
          this.originY = -1
          let coorInfo = { visible: false }
          this.$eventManage.fire('canvasMouseMove', { coorInfo })
        }
      }, 300)
    },
    onCanvasMouseUp(eventInfo) {
      let deletaX = eventInfo.clientX - this.originX
      let deletaY = eventInfo.clientY - this.originY
      if (Math.abs(deletaX) > 5 && Math.abs(deletaY) > 5) {
        this.currElemType = ''
      }
    },
    onCanvasMouseMove(event) {
      if (this.currElemType === 'EXTRUDE_EDGE' && this.currEdgeId) {
        if (this.originX !== -1 && this.originY !== -1) {
          let deletaX = event.clientX - this.originX
          let deletaY = event.clientY - this.originY
          if (Math.abs(deletaX) > 5 && Math.abs(deletaY) > 5) {
            this.originX = -1
            this.originY = -1
            let coorInfo = { visible: false }
            this.$eventManage.fire('canvasMouseMove', { coorInfo })
          }
        }
        return
      }

      if (!this.isPickUpHeightEnable && this.currMode !== 'create') return

      let tipContent = ''

      if (this.isPickUpHeightEnable) {
        tipContent = '左键拾取高度并应用，右键取消'
      }

      let coorInfo = {
        visible: true,
        tipContent,
        clientX: event.clientX,
        clientY: event.clientY
      }
      this.$eventManage.fire('canvasMouseMove', { coorInfo })
    },
    onCanvasMouseLeave() {
      let coorInfo = { visible: false }
      this.$eventManage.fire('canvasMouseMove', { coorInfo })
    },
    // 根据开挖区域获取受影响的数据集
    getAffectDataSetList(extrudeInfo) {
      const BlackHole3D = window.BlackHole3D

      let extrudeID = extrudeInfo.id
      let currExtrudeData = BlackHole3D.Extrude.getData([extrudeID])
      let currExtrudeInfo = currExtrudeData[0]

      // 将开挖区域顶点格式化，方便turf.js调用
      let rgnList = currExtrudeInfo.rgnList
      let extrudeRgn = rgnList[0]
      extrudeRgn = extrudeRgn.map(item => {
        return item.slice(0, 2)
      })
      extrudeRgn.push(extrudeRgn[0])

      let dataSets = this.findAllDataSets()

      // 开挖不支持的数据集类型(15:点云, 19:单构件, 21:矢量, 22:二维图纸)
      const unSupportDataSetType = [15, 19, 21, 22]

      // 剔除不支持开挖的数据集类型
      // prettier-ignore
      dataSets = dataSets.filter((el) => !unSupportDataSetType.includes(el.dataSetType));

      let affectDataSetList = []
      let extrudeGeoPoints = this.getGeoCoordList(extrudeRgn)
      extrudeGeoPoints = extrudeGeoPoints.map(item => {
        return item.slice(0, 2)
      })
      let extrudePolygon = turf.polygon([extrudeGeoPoints])
      dataSets.forEach(item => {
        let resId = item.dataSetId.replaceAll('-', '')
        let dataSetBV
        if (item.dataSetType === 0) {
          dataSetBV = BlackHole3D.BIM.getTotalBV(resId)
        } else {
          dataSetBV = BlackHole3D.Grid.getDataSetBV(resId)
        }

        // prettier-ignore
        let isDataSetAffected = this.isDataSetAffected(extrudePolygon, dataSetBV);
        let terrId = BlackHole3D.Terrain.getDataSetTerrId(resId)

        if (isDataSetAffected) {
          let obj = {
            dataSetId: item.dataSetId,
            dataSetType: item.dataSetType,
            resId: resId,
            isTerrType: terrId ? true : false,
            treeNodeId: item.nodeId,
            dataSetName: item.nodeName,
            zMax: dataSetBV[5]
          }
          affectDataSetList.push(obj)
        }
      })
      affectDataSetList = affectDataSetList.sort((a, b) => {
        return a.zMax - b.zMax
      })
      affectDataSetList = this.formatAffectDataSetList(affectDataSetList)

      return affectDataSetList
    },
    isDataSetAffected(extrudePolygon, dataSetBV) {
      let leftBottomPoint = [dataSetBV[0], dataSetBV[2], dataSetBV[4]]
      let rightTop = [dataSetBV[1], dataSetBV[3], dataSetBV[5]]

      let bboxPointList = [leftBottomPoint, rightTop]
      let bboxGeoPointList = this.getGeoCoordList(bboxPointList)
      bboxGeoPointList = bboxGeoPointList.map(item => {
        return item.slice(0, 2)
      })

      let diagonalLine = turf.lineString(bboxGeoPointList)
      let bbox = turf.bbox(diagonalLine)
      let bboxPolygon = turf.bboxPolygon(bbox)

      // 开挖区域是否包含数据集
      let isWithin = turf.booleanWithin(extrudePolygon, bboxPolygon)
      let isIntersect = turf.booleanIntersects(extrudePolygon, bboxPolygon)

      if (isWithin || isIntersect) {
        return true
      } else {
        return false
      }
    },
    formatAffectDataSetList(affectDataSetList) {
      const BlackHole3D = window.BlackHole3D

      let formatList = []
      let terrDataSetList = affectDataSetList.filter(el => el.isTerrType)
      let terrainGroups = []
      terrDataSetList.forEach(item => {
        let terrId = BlackHole3D.Terrain.getDataSetTerrId(item.resId)
        let dataSetIds = BlackHole3D.Terrain.getTerrSubAllDataSetId(terrId)
        let find = terrainGroups.find(el => el.terrId === terrId)
        if (!find) {
          let obj = {
            terrId,
            linkDataSets: []
          }
          dataSetIds.forEach(el => {
            let findDataSet = affectDataSetList.find(data => data.resId === el)
            if (findDataSet) {
              obj.linkDataSets.push(findDataSet)
            }
          })
          obj.linkDataSets = obj.linkDataSets.sort((a, b) => {
            return a.zMax - b.zMax
          })

          let defaultDataSet = obj.linkDataSets[0]
          obj.dataSetId = defaultDataSet.dataSetId
          obj.dataSetType = defaultDataSet.dataSetType
          obj.resId = defaultDataSet.resId
          obj.isTerrType = defaultDataSet.isTerrType
          obj.treeNodeId = defaultDataSet.nodeId
          obj.dataSetName = defaultDataSet.dataSetName
          obj.zMax = defaultDataSet.zMax

          terrainGroups.push(obj)
        }
      })

      let notTerrDataSetList = affectDataSetList.filter(el => !el.isTerrType)
      formatList = [...notTerrDataSetList, ...terrainGroups]
      formatList = formatList.sort((a, b) => {
        return a.zMax - b.zMax
      })

      return formatList
    },
    setPanelStyle() {
      this.$nextTick(() => {
        let domRef = this.$refs.dom.$el
        let panelHeaderDom = domRef.querySelector('.header-box')
        let panelContentDom = domRef.querySelector('.content')
        let height = panelHeaderDom.offsetHeight + panelContentDom.offsetHeight

        domRef.style.height = `${height}px`
        domRef.style.minHeight = `${height}px`
      })
    },
    getExtrudeRegData(extrudeID) {
      const Extrude = window.BlackHole3D.Extrude

      let extrudeData = Extrude.getData([extrudeID])
      let extrudeInfo = extrudeData[0]
      let rgnList = extrudeInfo.rgnList
      let pointList = rgnList[0]
      let transformedCoordList = this.getTransformedCoordList(pointList)

      let coordinates = transformedCoordList.map(item => {
        return item.slice(0, 2)
      })
      let heights = transformedCoordList.map(item => {
        return item.slice(2)[0]
      })

      let geoJson = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: {
              type: 'Polygon',
              coordinates: [coordinates]
            },
            properties: {
              heights
            }
          }
        ]
      }

      return geoJson
    },
    getTransformedCoordList(sourceCoordList) {
      let transformedCoordList = this.getGeoCoordList(sourceCoordList)

      // 判断数据是否首尾点重合，防止导出数据导入时，自相交校验失败
      let firstPoint = transformedCoordList[0]
      let lastPoint = transformedCoordList[transformedCoordList.length - 1]
      if (firstPoint[0] !== lastPoint[0] || firstPoint[1] !== lastPoint[1]) {
        transformedCoordList.push(firstPoint)
      }

      return transformedCoordList
    },
    getGeoCoordList(sourceCoordList) {
      const Coordinate = window.BlackHole3D.Coordinate
      const targetDataCrs = 'EPSG:4326'

      let transformedCoordList = []
      let engineWorldCrs = Coordinate.getEngineWorldCRS()
      if (engineWorldCrs) {
        sourceCoordList.forEach(item => {
          // prettier-ignore
          let point = Coordinate.getTransEngineCoords(true, targetDataCrs, [item]);
          transformedCoordList.push(point[0])
        })
      } else {
        let destCRS = 'EPSG:3857'
        sourceCoordList.forEach(item => {
          item.push(0)
        })
        // prettier-ignore
        transformedCoordList = Coordinate.getTransGeoCoords(destCRS, targetDataCrs, sourceCoordList);
      }

      return transformedCoordList
    },
    getCurrTexture(textureId) {
      let find = this.textureList.find(el => el.textureId === textureId)
      return find.texturePicPath
    },
    getStepIndexClassName(step) {
      let className = 'dialog-label step-index-box'
      if (this.activeSteps.includes(step)) {
        className += ' actived'
      }

      if (this.currStep === step) {
        className += ' active'
      }
      return className
    },
    getStepNameClassName(step) {
      let className = 'dialog-label step-name-box'
      if (this.currStep === step) {
        className += ' active'
      }
      return className
    },
    // 打开其他面板前给出提示
    openOtherPanelCheck() {
      return new Promise(resolve => {
        let isExtrudeRegChange = this.isRegChange()
        let isExtrudeAttrChange = this.isAttrChange()
        if (!isExtrudeRegChange && !isExtrudeAttrChange) {
          if (this.currStep === 1) {
            window.BlackHole3D.Extrude.endEditState()
          }
          this.closeExtrudePanel()
          resolve(true)
        } else {
          // prettier-ignore
          let message = '正在编辑开挖，请先结束编辑再执行相关操作';
          let options = {
            message,
            type: 'warning',
            duration: 5000,
            showClose: true
          }
          this.$message(options)
          resolve(false)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-drag-panel {
  left: 6px;
  top: 6px;
  width: 360px;
  height: unset;
  min-width: 360px;

  .common-button-box {
    display: flex;
    justify-content: end;

    .el-button {
      margin-right: 0px;
      border-radius: 4px;
    }
  }

  .edit-extrude-box {
    padding: 15px;

    .steps-box {
      display: flex;
      border-radius: 5px;

      .step-item-box {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        font-size: 14px;

        .step-index-box {
          width: 16px;
          height: 16px;
          font-size: 12px;
          border: 1px solid var(--extrude-step-line);
          border-radius: 50%;
          line-height: 14px;

          &.active.actived {
            color: var(--aside-bg-color);
            border-color: var(--base-primary-color);
            background-color: var(--base-primary-color);
          }

          &.actived {
            color: var(--extrude-step-text-color);
            border-color: var(--extrude-step-line);
          }
        }

        .step-name-box {
          margin-left: 10px;
          color: var(--extrude-step-text-color);

          &.active.actived {
            color: var(--extrude-step-text-color);
          }

          &.active {
            color: var(--base-primary-color);
          }
        }
      }

      .step-connector-line {
        flex-grow: 1;
        margin: auto 10px;
        height: 2px;
        background: var(--extrude-step-line);
      }
    }

    .extrude-name-box {
      display: flex;
      align-items: center;
      margin-top: 15px;
      font-size: 14px;
      line-height: 32px;

      .name-box {
        flex-grow: 1;
        display: flex;
        text-align: left;
        overflow: hidden;

        .label {
          flex-shrink: 0;
        }
      }
    }

    .first-step-box {
      margin-top: 15px;

      .uniform-height-box {
        display: flex;
        margin-top: 15px;
        align-items: center;

        .label-box {
          display: flex;
          align-items: center;
          flex-shrink: 0;

          .name {
            font-size: 14px;
          }

          .icon-box {
            margin: 0px 3px;

            span {
              margin-top: 2px;
            }
          }
        }

        .icon-btn-box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          margin-left: 10px;
          border-radius: 4px;
          color: var(--extrude-texture-drawbtn-icon-color);
          cursor: pointer;
          background: var(--extrude-texture-drawbtn-bgColor);
          border: 1px solid var(--extrude-texture-drawbtn-boder-color);

          &.active {
            background: var(--extrude-texture-drawbtn-hover-bgColor);
          }

          &:hover {
            background: var(--extrude-texture-drawbtn-hover-bgColor);
          }
        }
      }
    }

    .last-step-box {
      margin: 10px 0px;
      font-size: 14px;

      .item-box {
        display: flex;
        align-items: center;
        margin-top: 15px;

        &:first-child {
          margin-top: 0px;
        }

        .label-box {
          display: flex;
          align-items: center;

          .extrudeMethod {
            white-space: nowrap;
          }

          .icon-box {
            margin: 0px 5px;
          }
        }

        .texture-box {
          position: relative;
          border: 1px solid var(--extrude-texture-border-color);

          .curr-texture-box {
            display: flex;
            align-items: center;
            cursor: pointer;
            background: var(--extrude-texture-btn-bgColor);

            .img-box {
              width: 30px;
              height: 30px;
              background-size: cover;
              background-position: center;
            }

            .icon-box {
              margin: auto;
              font-size: 14px;
              color: var(--extrude-texture-btn-color);
            }
          }

          .texture-select-box {
            position: absolute;
            top: 33px;
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            width: 215px;
            background: var(--input-bg-color);
            border-radius: 8px;
            border: 1px solid var(--extrude-texture-item-border-color);
            padding: 10px;
            gap: 10px;

            .texture-item-box {
              width: 30px;
              height: 30px;
              border: 1px solid var(--extrude-texture-item-border-color);
              border-radius: 3px;
              cursor: pointer;

              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                border-radius: 3px;
              }
            }
          }
        }

        .common-select-box {
          flex-grow: 1;
          text-align: left;
          margin-left: 10px;

          .primary-select {
            width: 100%;
          }

          :deep(.el-input__inner) {
            width: 100%;
          }
        }
      }

      .extrude-affect-list {
        height: 120px;
        margin-top: 15px;
        padding: 10px;
        color: var(--default-color);
        border-radius: 8px;
        text-align: left;
        overflow: hidden;
        border: 1px solid var(--extrude-step-footer-border-color);
        background: var(--input-bg-color);

        :deep(.el-scrollbar__wrap) {
          overflow-x: hidden;
          overflow-y: auto;
          // 兼容firefox浏览器
          scrollbar-width: none;

          &::-webkit-scrollbar {
            display: none;
          }
        }

        :deep(.el-radio-group) {
          width: 100%;
          padding-top: 2px;
        }

        .common-radio-box {
          margin-bottom: 5px;

          .link-dataset-box {
            &:last-child {
              .link-dataset-line {
                display: none;
              }
            }

            .link-tip-box {
              display: flex;
              align-items: center;

              .link-line {
                width: 10px;
                height: 1px;
                margin: 0px 2px;
                border: 1px dashed var(--base-border-dark-color19);
              }
            }

            .link-dataset-line {
              height: 10px;
              width: 1px;
              margin: 1px 6px;
              border: 1px dashed var(--base-border-dark-color19);
            }
          }

          .layer-name {
            margin-top: -3px;
          }
        }
      }
    }
  }

  .operation-box {
    border-top: 1px solid var(--extrude-step-footer-border-color);
    padding: 15px;
  }
}
</style>
